var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.77425 6.33039C6.77425 6.33039 6.88574 6.21878 7.10871 5.99557C7.33168 5.77236 7.44316 5.34527 7.44316 4.71432C7.44316 4.08337 7.22019 3.54468 6.77425 3.09825C6.32831 2.65182 5.79021 2.42861 5.15994 2.42861C4.52968 2.42861 3.99158 2.65182 3.54564 3.09825C3.0997 3.54468 2.87672 4.08337 2.87672 4.71432C2.87672 5.34527 3.0997 5.88396 3.54564 6.33039C3.99158 6.77682 4.52968 7.00003 5.15994 7.00003C5.79021 7.00003 6.32831 6.77682 6.77425 6.33039ZM9.72638 4.71432C9.72638 5.36313 9.62827 5.89587 9.43206 6.31253L6.18561 13.2232C6.09047 13.4197 5.94926 13.5744 5.76196 13.6875C5.57467 13.8006 5.374 13.8572 5.15994 13.8572C4.94589 13.8572 4.74522 13.8006 4.55792 13.6875C4.37063 13.5744 4.23239 13.4197 4.1432 13.2232L0.887827 6.31253C0.691613 5.89587 0.593506 5.36313 0.593506 4.71432C0.593506 3.45242 1.03945 2.37503 1.93133 1.48218C2.82321 0.58932 3.89942 0.142891 5.15994 0.142891C6.42047 0.142891 7.49668 0.58932 8.38856 1.48218C9.28044 2.37503 9.72638 3.45242 9.72638 4.71432Z",
    fill: "#F985C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.b5278f2d9c100266b07434a0d8cf789f.svg";
export { ForwardRef as ReactComponent };